import React, { useState } from 'react'
import classNames from "classnames/bind"

import ToolTip from 'components/shared/toolTip/ToolTip'
import styles from './text-field.module.scss';
const cx = classNames.bind(styles)

export const TextField = ({props}) => {

    const [isFocused, setFocus] = useState()

    const {
        type,
        name,
        id,
        value,
        handleOnChange,
        icon,
        hasError,
        isRequired,
        requiredText,
        label,
        placeholder,
        hasTooltip,
        tooltipMessage
    } = props

    const handleFocus = () => {
        setFocus(true)
    }

    const handleBlur = () => {
        setFocus(false)
    }

    return (
        <div className={cx(['outer-text-field-wrapper'])}>
            <label htmlFor={name}>
                <span className={cx('label-wrapper')}>
                    {label}
                    {isRequired && <sup>*</sup>}

                    {hasTooltip &&
                        <span className={cx('tooltip-wrapper')}>
                            <ToolTip
                                message={tooltipMessage}
                            />
                        </span>
                    }
                </span>
                <span className={cx(['input-wrapper'], {
                    'input-wrapper__focused': isFocused === true,
                    'input-wrapper__error': hasError === true
                })}>
                    <input
                        type={type}
                        name={name}
                        id={id}
                        value={value}
                        onChange={(e) => handleOnChange(e)}
                        onFocus={() => handleFocus()}
                        onBlur={() => handleBlur()}
                        placeholder={placeholder}
                    />
                </span>

                {icon &&
                    <span className={cx('icon-wrapper')}>

                    </span>
                }
            </label>
            {hasError && requiredText &&
                <p className={cx('required-text')}>{requiredText}</p>
            }
        </div>
    )
}

export default TextField